//* 语言环境中间件
//* 当响应头携带X-Custom-Language时，会根据请求头中的Referer是否同源来判断当前请求是否更换语言环境
import { isbot } from "isbot";//爬虫检测库
export default defineNuxtRouteMiddleware(async (to, from) => {
    //* 域名映射表
    const mapping: Record<string, string | undefined> = { "rddc.tsinghua-gd.org": "172.21.0.70:3000" };
    //* 检测成功后的处理函数
    const success = (data: string) => {
        const result = routerResolve(to.fullPath, data);
        if (typeof result.route != "string" && result.route?.meta?.routeLanguage == data) {
            return navigateTo(result.route, { redirectCode: 200 });
        }
    };

    //* 解析函数
    const resolve = (data?: string) => {
        if (data?.startsWith("zh")) return "zh";
        else {
            return "en";
        }
    };

    //* 请求头数据初始化
    const headers = useRequestHeaders();
    //* 检测是否存在对应的语言路由，进行爬虫检测，爬虫不进行语言环境切换
    if (import.meta.server && !isbot(headers["user-agent"])) {
        const language = resolve(headers["accept-language"]);
        if (["zh", "en"].includes(language) && to.meta.routeLanguage != language) {
            try {
                const url = new URL(headers.referer);
                if ((mapping[url.host] || url.host) != headers.host) {
                    return success(language);
                }
            } catch {
                return success(language);
            }
        }
    }
});
